import React, { Component } from 'react';

import getSelectField from '../../fields/select';
import getFonts from '../../../Functions/config/fonts';
import { HexAlphaColorPicker, HexColorInput } from "react-colorful";

class Button extends Component {

    constructor(props) {
        super(props);
    }

    setColorsAndPreview = async (type, color) => {
        const { setColorsAndPreview } = this.props;
        await setColorsAndPreview('button', type, color);
    }

    setButtonColor = async (color) => {
        await this.setColorsAndPreview('buttonColor', color);
    }

    setButtonBg = async (color) => {
        await this.setColorsAndPreview('buttonBg', color);
    }

    setButtonBoxShadow = async (color) => {
        await this.setColorsAndPreview('buttonBoxShadow', color);
    }

    setButtonHover = async (color) => {
        await this.setColorsAndPreview('buttonHover', color);
    }

    setButtonHoverText = async (color) => {
        await this.setColorsAndPreview('buttonHoverText', color);
    }

    setButtonHoverBg = async (color) => {
        await this.setColorsAndPreview('buttonHoverBg', color);
    }

    render(){

        const { widget, handleInputChange, toggleColorPicker } = this.props;
        const { prorated } = widget.htmlData;
        const fontOptions = getFonts();

        return(

            <div className="mjwi-acc-panel-wrapper">

                <div className='mjwi-row'>    
                    <div className='mjwi-col33'>
                            <label>
                                Font Family
                            </label>                                    
                        </div>
                        <div className='mjwi-col66'>
                            {getSelectField('buttonFontFamily', fontOptions, prorated.button.buttonFontFamily, handleInputChange)}
                        </div>
                </div>

                <div className='mjwi-row'>    
                    <div className='mjwi-col33 mjwi-row'>
                        <label htmlFor="buttonFontSize">Size</label>&nbsp;
                        <input
                            type="number"
                            name="buttonFontSize"
                            value={prorated.button.buttonFontSize}
                            onChange={handleInputChange}
                        />&nbsp;px
                    </div>
                </div>

                <div className='mjwi-row'>
                    <div className='mjwi-col33'>
                        <label>Color</label>
                    </div>
                    <div className='mjwi-col66 mjwi-clr-picker'>
                        
                        <span className="clrPickerVal" onClick={toggleColorPicker} style={{ backgroundColor: prorated.button.buttonColor }}></span>
                        <HexAlphaColorPicker color={prorated.button.buttonColor} onChange={this.setButtonColor} style={{display: "none"}} className="mjwi-apfl-color-picker" />
                        <HexColorInput color={prorated.button.buttonColor} onChange={this.setButtonColor} />
                    </div>
                </div>

                <div className='mjwi-row'>
                    <div className='mjwi-col33'>
                        <label>Background</label>
                    </div>
                    <div className='mjwi-col66 mjwi-clr-picker'>
                        
                        <span className="clrPickerVal" onClick={toggleColorPicker} style={{ backgroundColor: prorated.button.buttonBg }}></span>
                        <HexAlphaColorPicker color={prorated.button.buttonBg} onChange={this.setButtonBg} style={{display: "none"}} className="mjwi-apfl-color-picker" />
                        <HexColorInput color={prorated.button.buttonBg} onChange={this.setButtonBg} />
                    </div>
                </div>

                <div className='mjwi-row'>
                    <div className='mjwi-col33'>
                        <label>Shadow</label>
                    </div>
                    <div className='mjwi-col66 mjwi-clr-picker'>
                        
                        <span className="clrPickerVal" onClick={toggleColorPicker} style={{ backgroundColor: prorated.button.buttonBoxShadow }}></span>
                        <HexAlphaColorPicker color={prorated.button.buttonBoxShadow} onChange={this.setButtonBoxShadow} style={{display: "none"}} className="mjwi-apfl-color-picker" />
                        <HexColorInput color={prorated.button.buttonBoxShadow} onChange={this.setButtonBoxShadow} />
                    </div>
                </div>

                <div className='mjwi-row'>
                    <div className='mjwi-col33'>
                        <label>Hover Shadow</label>
                    </div>
                    <div className='mjwi-col66 mjwi-clr-picker'>
                        
                        <span className="clrPickerVal" onClick={toggleColorPicker} style={{ backgroundColor: prorated.button.buttonHover }}></span>
                        <HexAlphaColorPicker color={prorated.button.buttonHover} onChange={this.setButtonHover} style={{display: "none"}} className="mjwi-apfl-color-picker" />
                        <HexColorInput color={prorated.button.buttonHover} onChange={this.setButtonHover} />
                    </div>
                </div>

                <div className='mjwi-row'>
                    <div className='mjwi-col33'>
                        <label>Hover Text</label>
                    </div>
                    <div className='mjwi-col66 mjwi-clr-picker'>
                        
                        <span className="clrPickerVal" onClick={toggleColorPicker} style={{ backgroundColor: prorated.button.buttonHoverText }}></span>
                        <HexAlphaColorPicker color={prorated.button.buttonHoverText} onChange={this.setButtonHoverText} style={{display: "none"}} className="mjwi-apfl-color-picker" />
                        <HexColorInput color={prorated.button.buttonHoverText} onChange={this.setButtonHoverText} />
                    </div>
                </div>

                <div className='mjwi-row'>
                    <div className='mjwi-col33'>
                        <label>Hover Bg</label>
                    </div>
                    <div className='mjwi-col66 mjwi-clr-picker'>
                        
                        <span className="clrPickerVal" onClick={toggleColorPicker} style={{ backgroundColor: prorated.button.buttonHoverBg }}></span>
                        <HexAlphaColorPicker color={prorated.button.buttonHoverBg} onChange={this.setButtonHoverBg} style={{display: "none"}} className="mjwi-apfl-color-picker" />
                        <HexColorInput color={prorated.button.buttonHoverBg} onChange={this.setButtonHoverBg} />
                    </div>
                </div>
            </div>
        );
    }
}

export default Button;
